import React from 'react';
import type { ServiceUpdateModalWithoutProjectContext as ServiceUpdateModalWithProjectContextType } from '@atlassian/jira-spa-apps-servicedesk-service-update-modal-without-project-context/src/ui/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServiceUpdateModalWithProjectContext = lazyForPaint<
	typeof ServiceUpdateModalWithProjectContextType
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-service-update-modal-without-project-context", jiraSpaEntry: "async-servicedesk-service-update-modal-without-project-context" */ '@atlassian/jira-spa-apps-servicedesk-service-update-modal-without-project-context'
		),
);

const AsyncServiceUpdateModalWithProjectContext = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServiceUpdateModalWithProjectContext}
		pageId="spa-apps/servicedesk/service-update-modal"
		shouldShowSpinner
	/>
);

export default AsyncServiceUpdateModalWithProjectContext;
